import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { ProductPresentation } from './components/ProductPresentation';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { UrgencyTimer } from './components/UrgencyTimer';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-800 selection:bg-sky/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <TargetAudience data-id="element-4" />
      <ProductPresentation data-id="element-5" />
      <Modules data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Comparison data-id="element-8" />
      <UrgencyTimer data-id="element-9" />
      <Pricing data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}